module.exports = __webpack_public_path__ + "img/ABC互動英語.1cb9d13d.png";